<div class="block">
    <powerbi-report
        [embedConfig]="reportConfig" 
        [cssClassName]="reportClass" 
        [phasedEmbedding]="phasedEmbeddingFlag" 
        [eventHandlers]="eventHandlersMap">
    </powerbi-report>
</div>
